import styled from 'styled-components';
import { Trigger, Content, Viewport, Item } from '@radix-ui/react-select';

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  border-bottom: 1px solid #eee;
  background: white;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 6px 8px;
  border: none;
  font-size: 14px;
  outline: none;
  background: transparent;
`;

export const SearchIconWrapper = styled.span`
  color: #888;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SelectRoot = styled.div`
  position: relative;
`;

export const SelectTrigger = styled(Trigger)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--way-design-borderRadiusDefault);
  padding: 4px 12px;
  font-size: 14px;
  line-height: 1;
  gap: 12px;
  background-color: transparent;
  border: none;
  color: var(--way-colors-calendarInputColor);
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  width: 100%;

  &[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TriggerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const ValueContainer = styled.div`
  flex: 1;
  min-height: 20px;
  display: flex;
  align-items: center;
`;

export const SelectedValues = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const SelectedTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: var(--way-palette-black-10);
  color: #051e39;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
`;

export const RemoveButton = styled.span`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  margin-left: 4px;
  color: var(--way-colors-contrastColorShades-60);
  user-select: none;
  border-radius: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  position: relative;
  z-index: 100;
  pointer-events: auto;
  min-width: 20px;
  min-height: 20px;

  &:hover {
    color: #051e39;
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const Placeholder = styled.span`
  color: var(--way-colors-contrastColorShades-60);
`;

export const ClearButton = styled.span`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin: 0;
  color: var(--way-colors-contrastColorShades-60);
  user-select: none;
  position: relative;
  z-index: 10;

  &:hover {
    color: #051e39;
  }
`;

export const SelectContent = styled(Content)`
  overflow: hidden;
  background-color: white;
  border-radius: var(--way-design-borderRadiusDefault);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 9;
  min-width: var(--radix-select-trigger-width);
  max-width: var(--radix-select-trigger-width);
  max-height: 200px;
`;

export const SelectViewport = styled(Viewport)`
  padding: 8px 4px;
  background-color: white;
`;

export const SelectItem = styled(Item)`
  font-size: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 4px;
  position: relative;
  user-select: none;
  cursor: pointer;
  color: #051e39;
  background-color: white;
  transition: all 0.15s ease;
  border: 2px solid transparent;
  touch-action: manipulation;

  &[data-highlighted],
  &:hover {
    background-color: var(--way-palette-black-10);
    color: #051e39;
    border: 2px solid var(--way-colors-focusBorderColor);
  }

  &[data-selected='true'] {
    background-color: var(--way-palette-black-10);
  }
`;

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Checkmark = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: var(--way-colors-primaryColor);
  font-weight: bold;
  font-size: 12px;
`;
